
// ─────────────────────────────────────────────
// COMPONENT 5: ComparisonTable
// PLACEMENT: New section after #why, before #process
// Usage: <ComparisonTableSection />
// ─────────────────────────────────────────────
const COMPARE_ROWS = [
  { label: "AI + ERP + Cloud under one roof",       us: true,    them: false },
  { label: "Custom-built automation (not off-shelf)", us: true,  them: false },
  { label: "Post-launch model tuning",               us: true,    them: false },
  { label: "Outcome-mapped architecture",            us: true,    them: "Rarely" },
  { label: "24 / 7 monitoring + SLA",                us: true,    them: "Add-on cost" },
  { label: "Single point of contact",                us: true,    them: false },
  { label: "Architecture that evolves with AI",      us: true,    them: false },
];

export function ComparisonTableSection() {
  return (
    <section id="compare">
      <style>{`
        #compare { position: relative; z-index: 3; padding: 120px 0; }
        .rs-comp-wrap {
          background: rgba(14,22,35,0.9);
          border: 1px solid #1D3145;
          border-radius: 20px;
          overflow: hidden;
          max-width: 860px;
          margin: 0 auto;
        }
        .rs-comp-table { width: 100%; border-collapse: collapse; }
        .rs-comp-table thead th {
          font-family: 'JetBrains Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 16px 24px;
          text-align: left;
          border-bottom: 1px solid #1D3145;
          color: #A7B3C2;
        }
        .rs-comp-table thead th:nth-child(2) { color: #49D6FF; }
        .rs-comp-table tbody tr { transition: background 0.2s; }
        .rs-comp-table tbody tr:hover { background: rgba(29,161,242,0.04); }
        .rs-comp-table tbody td {
          padding: 14px 24px;
          border-bottom: 1px solid rgba(29,49,69,0.5);
          font-size: 14px;
          color: #A7B3C2;
          vertical-align: middle;
        }
        .rs-comp-table tbody tr:last-child td { border-bottom: none; }
        .rs-comp-table td:first-child { color: #D6E1EB; font-weight: 500; }
        .rs-check {
          color: #49D6FF;
          font-size: 18px;
          font-weight: 600;
        }
        .rs-cross { color: #2a3d52; font-size: 16px; }
        .rs-partial { font-size: 12px; color: #5d7a93; font-family: 'JetBrains Mono', monospace; }
      `}</style>
      <div className="container">
        <div className="section-head reveal">
          <div className="eyebrow">Us vs. the rest</div>
          <h2>Most agencies ship parts. We ship the whole system.</h2>
          <p>Here&apos;s what you actually get with Readal versus the typical vendor relationship.</p>
        </div>
        <div className="rs-comp-wrap reveal">
          <table className="rs-comp-table">
            <thead>
              <tr>
                <th>What you get</th>
                <th>Readal Systems</th>
                <th>Typical Agency</th>
              </tr>
            </thead>
            <tbody>
              {COMPARE_ROWS.map((row, i) => (
                <tr key={i}>
                  <td>{row.label}</td>
                  <td><span className="rs-check">✓</span></td>
                  <td>
                    {row.them === true ? (
                      <span className="rs-check">✓</span>
                    ) : row.them === false ? (
                      <span className="rs-cross">✗</span>
                    ) : (
                      <span className="rs-partial">{row.them}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
